import { createApp } from "vue";
import { createPinia } from "pinia";
import VueLogger from "vuejs3-logger";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { LogLevels } from "@/enums/LogLevels";
import { useEnvironment } from "@/composables/useEnvironment";

// @see https://pinia.vuejs.org/
const pinia = createPinia();

const { getEnvironmentType } = useEnvironment();
const isProduction = getEnvironmentType() === "production";
const loggerOptions = {
  isEnabled: true,
  logLevel: isProduction ? LogLevels.ERROR : LogLevels.DEBUG,
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};

createApp(App)
  .use(VueLogger, loggerOptions)
  .use(router)
  .use(vuetify)
  .use(pinia)
  .mount("#app");
